import React from "react";
import { ChakraProvider, Box, Container, Heading, Link, Button, SimpleGrid, Image, Text } from "@chakra-ui/react";
import SummaryCards from "./components/SummaryCards";
import ProgressCharts from "./components/ProgressCharts";

function App() {
  return (
    <ChakraProvider>
      <Box bg="#FF8C00" py={4} color="white">
        <Container maxW="container.xl">
          <Heading as="h1" size="lg">
            Running Training Progression
          </Heading>
          <Box display="flex" alignItems="center" mt={2}>
            <Link href="https://tacticmethod.com" isExternal color="white" fontWeight="bold" mr={2}>
              Training program by <strong>Alex Parker</strong>'s #tacticrunclub at <strong>TacticMethod</strong>
            </Link>
            <Image
              src="/tactic.png"
              alt="Tactic Logo"
              boxSize="40px"
              width="40px"
              height="48px" // 20% more than 40px width
            />
          </Box>
          <Button
            as={Link}
            href="https://lpantano.github.io"
            target="_blank"
            leftIcon={<span className="material-icons">Learn More About Me</span>}
            colorScheme="teal"
            mt={2}
          >
            
          </Button>
        </Container>
      </Box>
      <Container maxW="container.xl" py={8}>
        <SummaryCards />
        <Box mt={8}>
          <Heading as="h2" size="md" mb={4}>Progress</Heading>
          <ProgressCharts />
        </Box>
        
        {/* Footer */}
        <Box mt={12} pt={6} borderTop="1px" borderColor="gray.200">
          <Text fontSize="sm" color="gray.600" textAlign="center">
            <Link href="https://www.flaticon.com/free-icons/shoes" title="shoes icons" isExternal color="blue.500">
              Favicon: Shoes icons created by Freepik - Flaticon
            </Link>
          </Text>
        </Box>
      </Container>
    </ChakraProvider>
  );
}

export default App;